import "Data/ServerSource";
/** @namespace GIS.Data */
NS("Cadastre.Data");

/**
 * GIS.Data.LayerFeatures source
 * @class
 * @extends Data.ServerSource
 */

Cadastre.Data.Owners = Class(Data.ServerSource, /** @lends GIS.Data.Cadastre.prototype */ {
	url: "Cadastre/Web/Owners/",

	fields: [
	],

});
